import { render, staticRenderFns } from "./CategoryVideoView.vue?vue&type=template&id=1ef4287c"
import script from "./CategoryVideoView.vue?vue&type=script&lang=js"
export * from "./CategoryVideoView.vue?vue&type=script&lang=js"
import style0 from "./CategoryVideoView.vue?vue&type=style&index=0&id=1ef4287c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports